import {
  ArrowRightCircleIcon,
  DevicePhoneMobileIcon,
  TruckIcon
} from '@heroicons/react/24/outline'

import SubMenuItem from './SubMenuItem'

const SubMenuItemsCustomers = () => (
  <>
    <SubMenuItem
      description="Let us come to you. Set up a regular food truck program or just a one time event"
      href="/hire-food-truck"
      Icon={TruckIcon}
      title="Hire a food truck"
    />

    <SubMenuItem
      description="Browse trucks near you and order online"
      href="/food-trucks-near-me"
      Icon={ArrowRightCircleIcon}
      title="Order now from trucks"
    />

    <SubMenuItem
      description={
        <div>
          <a
            className="p-4 text-orange-500 hover:text-orange-600 underline"
            href="https://apps.apple.com/us/app/best-food-trucks/id1513823045"
            rel="noopener noreferrer"
            target="_blank"
          >
            iOS
          </a>
          <a
            className="p-4 text-orange-500 hover:text-orange-600 underline"
            href="https://play.google.com/store/apps/details?id=com.bftcustomers&hl=en"
            rel="noopener noreferrer"
            target="_blank"
          >
            Android
          </a>
        </div>
      }
      Icon={DevicePhoneMobileIcon}
      title="Download the Customer App"
    />
  </>
)
export default SubMenuItemsCustomers
